export enum ContactChannelTypes {
    EMAIL = 'EMAIL',
    VOICE = 'VOICE',
    TEXT = 'TEXT'
}

export enum ContactChannelsStatusCode {
    INTERNAL_SERVER_ERROR = 500,
    MULTI_FACTOR_SESSION_EXPIRED = 437,
    SUCCESS = 200
}

export enum MultiFactorStatusCode {
    MULTIFACTOR_INVALID_OTP = 431,
    MULTIFACTOR_OTP_EXPIRED = 432,
    MULTIFACTOR_REDIRECT_PASSWORD_INTERRUPT = 428,
    MULTIFACTOR_LOCKED = 436,
    MULTIFACTOR_SESSION_TIMEOUT = 437,
    MULTIFACTOR_SYSTEM_ERROR = 500,
    MULTIFACTOR_MFA_TOKEN_EXPIRED = 419,
    MULTIFACTOR_SUCCESS = 200
}
